import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { adminApi } from "../../services/api";
import AdminPanel from "../../components/admin/AdminPanel";
import AdminTable from "../../components/admin/AdminTable";
import AdminFilter from "../../components/admin/AdminFilter";
import useAdminData from "../../components/admin/useAdminData";
import { unwrap, params, formatDate } from "../../components/admin/adminFormat";

export default function Cases() {
  const { t } = useTranslation();
  const { locale } = useOutletContext();
  const [form, setForm] = useState({ type: "all", status: "", category: "" });
  const [query, setQuery] = useState({ type: "all" });
  const [matchingStatus, setMatchingStatus] = useState("");
  const { data: objects, loading: objectsLoading } = useAdminData(async () => unwrap(await adminApi.getObjects(query)), [query]);
  const { data: matchingsData, loading: matchingsLoading } = useAdminData(async () => unwrap(await adminApi.getMatchings(params({ status: matchingStatus }))), [matchingStatus]);
  const matchings = matchingsData || [];

  const rows = [
    ...(objects?.lost || []).map((item) => [t("admin.lost"), item.reference, item.name, item.category, item.status, formatDate(item.createdAt, locale)]),
    ...(objects?.found || []).map((item) => [t("admin.found"), item.reference, item.name, item.category, item.status, formatDate(item.createdAt, locale)]),
  ];

  return (
    <>
      <AdminFilter t={t} form={form} setForm={setForm} fields={["type", "status", "category"]} submit={() => setQuery(params(form))} />
      <AdminPanel>
        {objectsLoading ? t("common.loading") : (
          <AdminTable t={t} headers={[t("admin.type"), t("admin.reference"), t("admin.name"), t("admin.category"), t("admin.status"), t("admin.date")]} rows={rows} />
        )}
      </AdminPanel>
      <AdminPanel>
        <h2>{t("admin.matching_followup")}</h2>
        <select value={matchingStatus} onChange={(event) => setMatchingStatus(event.target.value)}>
          <option value="">{t("admin.all")}</option>
          <option value="DETECTE">DETECTE</option>
          <option value="CONFIRME_MUTUEL">CONFIRME_MUTUEL</option>
          <option value="REJETE">REJETE</option>
        </select>
        {matchingsLoading ? t("common.loading") : (
          <AdminTable
            t={t}
            headers={[t("admin.score"), t("admin.status"), t("admin.lost"), t("admin.found")]}
            rows={matchings.map((item) => [item.totalScore, item.status, item.lostObject?.reference || "—", item.foundObject?.reference || "—"])}
          />
        )}
      </AdminPanel>
    </>
  );
}
